<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Turnos",
            items: [
                {
                    text: "Home",
                    href: "/"
                },
                {
                    text: "turnos",
                    active: true
                }
            ],
            turnos:{},
            turno:null,
            isLoading:false,
            datos:{
                name: '',
                horario_inicio: null,
                horario_termino: null,
            },
            valor_editar:{},
            horariosi: [
                { "value": "00:00", "text": "00:00 AM" },
                { "value": "01:00", "text": "01:00 AM" },
                { "value": "02:00", "text": "02:00 AM" },
                { "value": "03:00", "text": "03:00 AM" },
                { "value": "04:00", "text": "04:00 AM" },
                { "value": "05:00", "text": "05:00 AM" },
                { "value": "06:00", "text": "06:00 AM" },
                { "value": "07:00", "text": "07:00 AM" },
                { "value": "08:00", "text": "08:00 AM" },
                { "value": "09:00", "text": "09:00 AM" },
                { "value": "10:00", "text": "10:00 AM" },
                { "value": "11:00", "text": "11:00 AM" },
                { "value": "12:00", "text": "12:00 PM" },
                { "value": "13:00", "text": "01:00 PM" },
                { "value": "14:00", "text": "02:00 PM" },
                { "value": "15:00", "text": "03:00 PM" },
                { "value": "16:00", "text": "04:00 PM" },
                { "value": "17:00", "text": "05:00 PM" },
                { "value": "18:00", "text": "06:00 PM" },
                { "value": "19:00", "text": "07:00 PM" },
                { "value": "20:00", "text": "08:00 PM" },
                { "value": "21:00", "text": "09:00 PM" },
                { "value": "22:00", "text": "10:00 PM" },
                { "value": "23:00", "text": "11:00 PM" }
            ],horariosf: [
                { "value": "00:59", "text": "00:59 AM" },
                { "value": "01:59", "text": "01:59 AM" },
                { "value": "02:59", "text": "02:59 AM" },
                { "value": "03:59", "text": "03:59 AM" },
                { "value": "04:59", "text": "04:59 AM" },
                { "value": "05:59", "text": "05:59 AM" },
                { "value": "06:59", "text": "06:59 AM" },
                { "value": "07:59", "text": "07:59 AM" },
                { "value": "08:59", "text": "08:59 AM" },
                { "value": "09:59", "text": "09:59 AM" },
                { "value": "10:59", "text": "10:59 AM" },
                { "value": "11:59", "text": "11:59 AM" },
                { "value": "12:59", "text": "12:59 PM" },
                { "value": "13:59", "text": "01:59 PM" },
                { "value": "14:59", "text": "02:59 PM" },
                { "value": "15:59", "text": "03:59 PM" },
                { "value": "16:59", "text": "04:59 PM" },
                { "value": "17:59", "text": "05:59 PM" },
                { "value": "18:59", "text": "06:59 PM" },
                { "value": "19:59", "text": "07:59 PM" },
                { "value": "20:59", "text": "08:59 PM" },
                { "value": "21:59", "text": "09:59 PM" },
                { "value": "22:59", "text": "10:59 PM" },
                { "value": "23:59", "text": "11:59 PM" }
            ]
        };
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/turnos').then(res=>{
                    this.turnos = res.data.datos;
                    this.$toasted.success('Datos cargados!');
                })  
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
        },
        agregar(){
            this.isLoading=true
            axios.post('/api/turnos',this.datos).then(res=>{
                if(res.data.estado){
                    this.turno = res.data.turno;
                    this.datos.name=''
                    this.get_data()
                }else{
                    alert('error al agregar')
                }
                this.isLoading=false
            })
        },
        eliminar(id){
            this.isLoading=true
            axios.delete('/api/turnos/'+id).then(res=>{
                this.turnos = res.data.datos;
                this.get_data()
                this.isLoading=false
            })
        },
        editar_turno(turno){
            this.valor_editar=turno
            this.$refs['editar_turno'].show();
        },
        guardar_valor(){
            if(this.valor_editar.name!=""){
                this.isLoading=true
                axios.put('/api/turnos/'+this.valor_editar.id,this.valor_editar).then(res=>{
                    if(res.data.estado){
                        this.turno=res.data.turno
                        this.get_data()
                        this.isLoading=false    
                        this.$refs['editar_turno'].hide();
                        this.valor_editar={}
                    }else{
                        Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: "Error al agregar",
                                text: '',
                                showConfirmButton: true,
                                timer: 5000
                            });
                    }
                    this.isLoading=false
                })
            }else{
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result)=>{
                    this.$refs['editar_turno'].show();
                })
            }
        },
    },
    mounted() {
        this.get_data()
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <b-modal id="editar_turno" ref="editar_turno" hide-footer>
                <template #modal-title>Editar turno {{ valor_editar.name }}</template>
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-12 col-xl-12">
                        <!-- <img src="/images/Logo-Menu.png" alt class="img-fluid pb-3"/> -->
                        <div class="card overflow-hidden">
                            <div class="card-body pt-5">
                                <b-form-group id="input-group-122" label="Horario de inicio" label-for="input-122">
                                    <b-form-select v-model="valor_editar.horario_ini" :options="horariosi" placeholder="Seleccione hora de inicio"></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-122" label="Horario de termino" label-for="input-122">
                                    <b-form-select v-model="valor_editar.horario_fin" :options="horariosf" placeholder="Seleccione hora de termino"></b-form-select>
                                </b-form-group>
                                <button class="btn btn-success btn-sm py-2 px-4" @click="guardar_valor()">
                                    Guardar
                                </button>
                            </div>
                        </div>
                        <!-- end row -->
                    </div>
                    <!-- end col -->
                </div>
            </b-modal>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <th class="py-0 px-1">#</th>
                                <th class="py-0 px-1">NOMBRE</th>
                                <th class="py-0 px-1">INICIO</th>
                                <th class="py-0 px-1">FIN</th>
                                <th class="py-0 px-1"></th>
                            </thead>
                            <tbody>
                                <tr v-for="(m, i) in turnos" :key="i">
                                    <td class="py-0 px-1">{{ i + 1 }}</td>
                                    <td class="py-0 px-1">{{ m.name }}</td>
                                    <td class="py-0 px-1">{{ m.horario_ini }}</td>
                                    <td class="py-0 px-1">{{ m.horario_fin }}</td>
                                    <td class="py-0 px-1">
                                        <div class="btn-group">
                                            <button class="btn btn-success btn-sm py-1 px-2" title="Editar" @click="editar_turno(m)">
                                                <i class="fas fa-edit"></i>
                                            </button>
                                            <a @click="eliminar(m.id)" class="btn btn-danger btn-sm py-1 px-2">
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Nombre">
                            <b-form-input for="text" placeholder="Nombre" v-model="datos.name"  ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Hora de inicio" label-cols-sm="12" label-cols-lg="3">
                            <b-form-select v-model="datos.horario_ini" :options="horariosi" placeholder="Seleccione hora de inicio"></b-form-select>
                        </b-form-group>
                        <!-- Campo de Hora de Fin -->
                        <b-form-group label="Hora de fin" label-cols-sm="12" label-cols-lg="3">
                            <b-form-select v-model="datos.horario_fin" :options="horariosf" placeholder="Seleccione hora de fin"></b-form-select>
                        </b-form-group>
                        <b-button v-show="datos.name!==''" block variant="success" @click="agregar()">Agregar</b-button>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
